import { render } from "./sessions.vue?vue&type=template&id=b44b5bb0&scoped=true"
import script from "./sessions.vue?vue&type=script&lang=js"
export * from "./sessions.vue?vue&type=script&lang=js"

import "./sessions.vue?vue&type=style&index=0&id=b44b5bb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b44b5bb0"]])

export default __exports__